import { render, staticRenderFns } from "./Part2.vue?vue&type=template&id=1d937ef1&scoped=true"
var script = {}
import style0 from "./Part2.vue?vue&type=style&index=0&id=1d937ef1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d937ef1",
  null
  
)

export default component.exports